





import Vue from 'vue';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { types } from '@/modules/servis/zakazka/store/types';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../../store/edit';

export default Vue.extend({
	name: 'MicroPracovnikSelect',
	components: {
		PracovnikSelect: Pracovnik.components.Select,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
		validationProperty: { type: String, default: 'PracovnikId' },
		isDisabled: { type: Boolean, default: false },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_PRACOVNIK_SELECT_MAPPER}`,
			};
		},
	},
});
